import { render, staticRenderFns } from "./OfflineTransfer.vue?vue&type=template&id=608577ba&scoped=true"
import script from "./OfflineTransfer.vue?vue&type=script&lang=js"
export * from "./OfflineTransfer.vue?vue&type=script&lang=js"
import style0 from "./OfflineTransfer.vue?vue&type=style&index=0&id=608577ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608577ba",
  null
  
)

export default component.exports